const CHAT_ONLY_ROLE = 'chat_only';
const CMS_SINGAPORE_TENANT_ID = '00000000-0000-4000-a000-000000000002';

interface AccountPolicy {
  chatOnly?: boolean;
  defaultTenantId?: string;
}

const ACCOUNT_POLICIES = new Map<string, AccountPolicy>([
  ['mervin@cms', {
    defaultTenantId: CMS_SINGAPORE_TENANT_ID,
  }],
]);

function normalizeEmail(email: string | null | undefined): string {
  return (email ?? '').trim().toLowerCase();
}

function getAccountPolicy(email: string | null | undefined) {
  return ACCOUNT_POLICIES.get(normalizeEmail(email));
}

export function isChatOnlyAccess(user?: { role?: string; email?: string } | null): boolean {
  if (!user) return false;
  return user.role === CHAT_ONLY_ROLE || Boolean(getAccountPolicy(user.email)?.chatOnly);
}

export function isChatOnlyPath(pathname: string): boolean {
  return pathname === '/chat' || /^\/chat\/[^/]+$/.test(pathname);
}

export function getDefaultTenantIdForUser(user?: { email?: string } | null): string | null {
  return getAccountPolicy(user?.email)?.defaultTenantId ?? null;
}
